import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-roles-controller',
  templateUrl: './roles-controller.component.html',
  styleUrls: ['./roles-controller.component.css']
})
export class RolesControllerComponent implements OnInit {

  roles: any = [];
  rolesFilter: any = [];
  singleRoleData: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: any = 0;
  tableSize: number = 10;
  isLoading: any = false;
  searchKey: any = "";
  privilegeList: any;
  form: any | FormGroup;
  addSubmit: boolean = false;
  addButton: boolean = true;
  cid: any;
  editForm: any | FormGroup;
  editSubmit: boolean = false;
  editButton: boolean = true;
  privilegeListEdit: any = [];
  singleRoleDataEdit: any = {};

  constructor(private generic_service: GenericService, private fb: FormBuilder, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.form = this.fb.group({
      roleName: ['', [Validators.required]]
    });
    this.editForm = this.fb.group({
      roleName: ['', [Validators.required]]
    });
    this.getAllRoles();
    this.getAllPrivileges();
    this.getAllPrivilegesEdit();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  getAllRoles() {
    this.isLoading = true;
    this.generic_service.getAllRoles().subscribe(
      (res: any) => {
        this.roles = res.response;
        this.rolesFilter = res.response;
        this.totalRecords = res.response.length;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
      }
    )
  }

  getAllPrivileges() {
    this.generic_service.getAllPrivileges().subscribe(
      (response: any) => {
        console.log(response.response);
        this.privilegeList = response.response.screenGroupList ? response.response.screenGroupList : response.response;
        for (let i = 0; this.privilegeList.length > i; i++) {
          this.privilegeList[i].isChecked = false;
          for (let j = 0; this.privilegeList[i].screenPrivilegeList.length > j; j++) {
            let screen = this.privilegeList[i].screenPrivilegeList[j];
            screen.isChecked = false;
            screen.isView = screen.view || false;
            screen.isAdd = screen.add || false;
            screen.isDelete = screen.delete || false;
            screen.isModify = screen.modify || false;
            screen.isVerify = screen.verify || false;
            screen.isApprove = screen.approve || false;
            screen.isIssue = screen.issue || false;
            screen.isAttach = screen.attach || false;
            screen.isRemove = screen.remove || false;

            screen.view = screen.isView;
            screen.add = screen.isAdd;
            screen.delete = screen.isDelete;
            screen.modify = screen.isModify;
            screen.verify = screen.isVerify;
            screen.approve = screen.isApprove;
            screen.issue = screen.isIssue;
            screen.attach = screen.isAttach;
            screen.remove = screen.isRemove;
          }
        }
      }
    )
  }

  isChecked(event: any, i: any) {
    this.privilegeList[i].isChecked = event.target.checked;
    for (var j = 0; j < this.privilegeList[i].screenPrivilegeList.length; j++) {
      let screen = this.privilegeList[i].screenPrivilegeList[j];
      screen.isChecked = event.target.checked;
      if (event.target.checked) {
        screen.view = true;
        if (screen.isAdd) screen.add = true;
        if (screen.isModify) screen.modify = true;
        if (screen.isDelete) screen.delete = true;
        if (screen.isVerify) screen.verify = true;
        if (screen.isApprove) screen.approve = true;
        if (screen.isIssue) screen.issue = true;
        if (screen.isAttach) screen.attach = true;
        if (screen.isRemove) screen.remove = true;
      } else {
        screen.view = false;
        screen.add = false;
        screen.modify = false;
        screen.delete = false;
        screen.verify = false;
        screen.approve = false;
        screen.issue = false;
        screen.attach = false;
        screen.remove = false;
      }
    }
  }

  screenCheck(event: any, i: any, j: any) {
    let screen = this.privilegeList[i].screenPrivilegeList[j];
    screen.isChecked = event.target.checked;
    if (event.target.checked) {
      screen.view = true;
      if (screen.isAdd) screen.add = true;
      if (screen.isModify) screen.modify = true;
      if (screen.isDelete) screen.delete = true;
      if (screen.isVerify) screen.verify = true;
      if (screen.isApprove) screen.approve = true;
      if (screen.isIssue) screen.issue = true;
      if (screen.isAttach) screen.attach = true;
      if (screen.isRemove) screen.remove = true;
    } else {
      screen.view = false;
      screen.add = false;
      screen.modify = false;
      screen.delete = false;
      screen.verify = false;
      screen.approve = false;
      screen.issue = false;
      screen.attach = false;
      screen.remove = false;
    }
    this.privilegeList[i].isChecked = this.privilegeList[i].screenPrivilegeList.some((s: any) => s.isChecked);
  }

  addRole() {
    this.addSubmit = true;
    if (!this.form.valid) {
      this.toastr.error('Role name required');
      return;
    }

    let atleastOneRoleSelected = this.privilegeList.some((p: any) => p.isChecked);
    if (!atleastOneRoleSelected) {
      this.toastr.error('Select minimum one role');
      return;
    }

    this.addButton = false;
    let screenGroupList: any = [];

    for (let i = 0; i < this.privilegeList.length; i++) {
      if (this.privilegeList[i].isChecked) {
        let arr: any = {
          "version": Number(this.privilegeList[i].version || 0),
          "isActive": Boolean(this.privilegeList[i].isActive !== false),
          "description": String(this.privilegeList[i].description || ""),
          "seqNo": Number(this.privilegeList[i].seqNo || 0),
          "groupName": String(this.privilegeList[i].groupName || ""),
          "screenPrivilegeList": [],
          "cid": Number(this.privilegeList[i].cid || 0),
        };

        for (let j = 0; j < this.privilegeList[i].screenPrivilegeList.length; j++) {
          let screen = this.privilegeList[i].screenPrivilegeList[j];
          if (screen.isChecked) {
            let screenPrivilegeList = {
              "seqNo": Number(screen.seqNo || 0),
              "name": String(screen.name || ""),
              "add": Boolean(screen.add),
              "view": Boolean(screen.view),
              "modify": Boolean(screen.modify),
              "delete": Boolean(screen.delete),
              "verify": Boolean(screen.verify),
              "approve": Boolean(screen.approve),
              "issue": Boolean(screen.issue),
              "attach": Boolean(screen.attach),
              "remove": Boolean(screen.remove),
              "description": String(screen.description || ""),
              "originalName": String(screen.originalName || ""),
              "screenPrivilegeScopeList": screen.screenPrivilegeScopeList || []
            };



            arr.screenPrivilegeList.push(screenPrivilegeList);
          }
        }
        screenGroupList.push(arr);
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "roleName": String(this.form.get('roleName').value),
      "level": 0,
      "screenGroupList": screenGroupList,
      "cid": Number(this.cid || 0)
    };

    this.generic_service.addRole(body).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Role added successfully');
        document.getElementById("closeModalButton")?.click();
        this.form.reset();
        this.getAllPrivileges();
        this.getAllRoles();
        this.addButton = true;
        this.addSubmit = false;
      },
      (error: any) => {
        this.toastr.error(error.error?.errors?.[0]?.description || 'Error adding role');
        this.addButton = true;
      }
    );
  }

  addRoleClose() {
    this.form.reset();
    this.getAllPrivileges();
    this.getAllPrivilegesEdit();
  }

  getRoleById(roleId: any) {
    this.generic_service.getRoleById(roleId).subscribe(
      (response: any) => {
        this.singleRoleData = [];
        this.singleRoleData.push(response.response);
      }
    )
  }



  deleteRole(roleId: any) {
    // Implement delete logic here
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchKey = "";
    this.getAllRoles();
  }

  searchByRoleName(): void {
    const searchValue = this.searchKey.trim().toLowerCase();
    if (searchValue) {
      this.roles = this.rolesFilter.filter((role: any) =>
        role.roleName?.toLowerCase().includes(searchValue)
      );
      this.totalRecords = this.roles.length;
      this.pageNumber = 1;
      this.first = 0;
    } else {
      this.roles = [...this.rolesFilter];
      this.totalRecords = this.roles.length;
      this.pageNumber = 1;
      this.first = 0;
    }
  }


  getAllPrivilegesEdit() {
    this.generic_service.getAllPrivileges().subscribe(
      (response: any) => {
        this.privilegeListEdit = response.response.screenGroupList ? response.response.screenGroupList : response.response;
        for (let i = 0; this.privilegeListEdit.length > i; i++) {
          this.privilegeListEdit[i].isChecked = false;
          for (let j = 0; this.privilegeListEdit[i].screenPrivilegeList.length > j; j++) {
            let screen = this.privilegeListEdit[i].screenPrivilegeList[j];
            screen.isChecked = false;
            screen.isView = screen.view || false;
            screen.isAdd = screen.add || false;
            screen.isDelete = screen.delete || false;
            screen.isModify = screen.modify || false;
            screen.isVerify = screen.verify || false;
            screen.isApprove = screen.approve || false;
            screen.isIssue = screen.issue || false;
            screen.isAttach = screen.attach || false;
            screen.isRemove = screen.remove || false;

            screen.view = true;
            screen.add = true;
            screen.delete = true;
            screen.modify = true;
            screen.verify = true;
            screen.approve = true;
            screen.issue = true;
            screen.attach = true;
            screen.remove = true;
          }
        }
      }
    )
  }

  isCheckedEdit(event: any, i: any) {
    this.privilegeListEdit[i].isChecked = event.target.checked;
    for (var j = 0; j < this.privilegeListEdit[i].screenPrivilegeList.length; j++) {
      let screen = this.privilegeListEdit[i].screenPrivilegeList[j];
      screen.isChecked = event.target.checked;
      if (event.target.checked) {
        screen.view = true;
        if (screen.isAdd) screen.add = true;
        if (screen.isModify) screen.modify = true;
        if (screen.isDelete) screen.delete = true;
        if (screen.isVerify) screen.verify = true;
        if (screen.isApprove) screen.approve = true;
        if (screen.isIssue) screen.issue = true;
        if (screen.isAttach) screen.attach = true;
        if (screen.isRemove) screen.remove = true;
      } else {
        screen.view = false;
        screen.add = false;
        screen.modify = false;
        screen.delete = false;
        screen.verify = false;
        screen.approve = false;
        screen.issue = false;
        screen.attach = false;
        screen.remove = false;
      }
    }
  }

  screenCheckEdit(event: any, i: any, j: any) {
    let screen = this.privilegeListEdit[i].screenPrivilegeList[j];
    screen.isChecked = event.target.checked;
    if (event.target.checked) {
      screen.view = true;
      if (screen.isAdd) screen.add = true;
      if (screen.isModify) screen.modify = true;
      if (screen.isDelete) screen.delete = true;
      if (screen.isVerify) screen.verify = true;
      if (screen.isApprove) screen.approve = true;
      if (screen.isIssue) screen.issue = true;
      if (screen.isAttach) screen.attach = true;
      if (screen.isRemove) screen.remove = true;
    } else {
      screen.view = false;
      screen.add = false;
      screen.modify = false;
      screen.delete = false;
      screen.verify = false;
      screen.approve = false;
      screen.issue = false;
      screen.attach = false;
      screen.remove = false;
    }
    this.privilegeListEdit[i].isChecked = this.privilegeListEdit[i].screenPrivilegeList.some((s: any) => s.isChecked);
  }

  editRole(id: any) {
    this.generic_service.getRoleById(id).subscribe(
      (response: any) => {
        this.singleRoleDataEdit = response.response;
        this.editForm.patchValue({
          roleName: response.response.roleName
        });

        if (this.privilegeListEdit) {
          for (let i = 0; i < this.privilegeListEdit.length; i++) {
            this.privilegeListEdit[i].isChecked = false;
            for (let j = 0; j < this.privilegeListEdit[i].screenPrivilegeList.length; j++) {
              this.privilegeListEdit[i].screenPrivilegeList[j].isChecked = false;
            }
          }
        }

        if (response.response.screenGroupList && this.privilegeListEdit) {
          for (let i = 0; i < response.response.screenGroupList.length; i++) {
            for (let j = 0; j < this.privilegeListEdit.length; j++) {
              if (this.privilegeListEdit[j].groupName === response.response.screenGroupList[i].groupName) {
                this.privilegeListEdit[j].isChecked = true;
                for (let k = 0; k < response.response.screenGroupList[i].screenPrivilegeList.length; k++) {
                  for (let l = 0; l < this.privilegeListEdit[j].screenPrivilegeList.length; l++) {
                    if (response.response.screenGroupList[i].screenPrivilegeList[k].description === this.privilegeListEdit[j].screenPrivilegeList[l].description) {
                      let mapFrom = response.response.screenGroupList[i].screenPrivilegeList[k];
                      let mapTo = this.privilegeListEdit[j].screenPrivilegeList[l];
                      mapTo.isChecked = true;
                      mapTo.add = mapFrom.add;
                      mapTo.delete = mapFrom.delete;
                      mapTo.view = mapFrom.view;
                      mapTo.modify = mapFrom.modify;
                      mapTo.verify = mapFrom.verify;
                      mapTo.approve = mapFrom.approve;
                      mapTo.issue = mapFrom.issue;
                      mapTo.attach = mapFrom.attach;
                      mapTo.remove = mapFrom.remove;
                    }
                  }
                }
              }
            }
          }
        }
      }
    )
  }

  updateRole() {
    this.editSubmit = true;
    if (!this.editForm.valid) {
      this.toastr.error('Role name required');
      return;
    }

    let atleastOneRoleSelected = this.privilegeListEdit.some((p: any) => p.isChecked);
    if (!atleastOneRoleSelected) {
      this.toastr.error('Select minimum one role');
      return;
    }

    this.editButton = false;
    let screenGroupList: any = [];

    for (let i = 0; i < this.privilegeListEdit.length; i++) {
      if (this.privilegeListEdit[i].isChecked) {
        let arr: any = {
          "version": Number(this.privilegeListEdit[i].version || 0),
          "isActive": Boolean(this.privilegeListEdit[i].isActive !== false),
          "description": String(this.privilegeListEdit[i].description || ""),
          "seqNo": Number(this.privilegeListEdit[i].seqNo || 0),
          "groupName": String(this.privilegeListEdit[i].groupName || ""),
          "screenPrivilegeList": [],
          "cid": Number(this.privilegeListEdit[i].cid || 0),
        };

        for (let j = 0; j < this.privilegeListEdit[i].screenPrivilegeList.length; j++) {
          let screen = this.privilegeListEdit[i].screenPrivilegeList[j];
          if (screen.isChecked) {
            let screenPrivilegeList = {
              "seqNo": Number(screen.seqNo || 0),
              "name": String(screen.name || ""),
              "add": Boolean(screen.add),
              "view": Boolean(screen.view),
              "modify": Boolean(screen.modify),
              "delete": Boolean(screen.delete),
              "verify": Boolean(screen.verify),
              "approve": Boolean(screen.approve),
              "issue": Boolean(screen.issue),
              "attach": Boolean(screen.attach),
              "remove": Boolean(screen.remove),
              "description": String(screen.description || ""),
              "originalName": String(screen.originalName || ""),
              "screenPrivilegeScopeList": screen.screenPrivilegeScopeList || []
            };
            arr.screenPrivilegeList.push(screenPrivilegeList);
          }
        }
        screenGroupList.push(arr);
      }
    }

    let body = {
      "version": Number(this.singleRoleDataEdit.version || 0),
      "isActive": Boolean(this.singleRoleDataEdit.isActive !== false),
      "description": String(this.singleRoleDataEdit.description || ""),
      "id": String(this.singleRoleDataEdit.id || ""),
      "roleId": Number(this.singleRoleDataEdit.roleId),
      "roleName": String(this.editForm.get('roleName').value),
      "level": Number(this.singleRoleDataEdit.level || 0),
      "screenGroupList": screenGroupList,
      "cid": Number(this.singleRoleDataEdit.cid || 0),
    };

    this.generic_service.updateRole(body).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Role updated successfully');
        document.getElementById("closeModalButtonEdit")?.click();
        this.editForm.reset();
        this.getAllPrivilegesEdit();
        this.getAllRoles();
        this.editButton = true;
        this.editSubmit = false;
      },
      (error: any) => {
        this.toastr.error(error.error?.errors?.[0]?.description || 'Error updating role');
        this.editButton = true;
      }
    );
  }

  editRoleClose() {
    this.editForm.reset();
    this.getAllPrivilegesEdit();
  }
}
